import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a 1.6 x 0.8 work desk on 2x1 tiles: light oak top at
// 0.74, matte-black frame legs and a slim modesty panel on the front (+Z).
const TOP = "#c8975a";
const FRAME = "#2e2e30";

export const officeDesk = defineModel({
  id: "office-desk",
  batchId: "modern",
  name: "Office desk",
  tags: ["modern", "interior", "furniture", "office", "table", "desk"],
  summary: "A 1.6-metre work desk with a light top and matte-black frame.",
  tiles: { w: 2, h: 1 },
  footprint: 1.3,
  parts(): Part[] {
    return [
      // desktop (top surface at 0.74)
      { geometry: new THREE.BoxGeometry(1.6, 0.04, 0.8), color: TOP, position: [0, 0.72, 0] },
      // frame legs
      { geometry: new THREE.BoxGeometry(0.05, 0.7, 0.05), color: FRAME, position: [-0.74, 0.35, -0.34] },
      { geometry: new THREE.BoxGeometry(0.05, 0.7, 0.05), color: FRAME, position: [0.74, 0.35, -0.34] },
      { geometry: new THREE.BoxGeometry(0.05, 0.7, 0.05), color: FRAME, position: [-0.74, 0.35, 0.34] },
      { geometry: new THREE.BoxGeometry(0.05, 0.7, 0.05), color: FRAME, position: [0.74, 0.35, 0.34] },
      // side rails joining the leg pairs
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.68), color: FRAME, position: [-0.74, 0.675, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.68), color: FRAME, position: [0.74, 0.675, 0] },
      // slim modesty panel on the front (+Z) side
      { geometry: new THREE.BoxGeometry(1.44, 0.32, 0.025), color: FRAME, position: [0, 0.52, 0.3] },
    ];
  },
  animations: [],
});
